import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CmsNavigationComponent } from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CmsComponentData } from '@spartacus/storefront';
import { Observable, combineLatest, forkJoin, of } from 'rxjs';
import { map, pluck, switchMap } from 'rxjs/operators';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { FooterService } from 'src/app/service/footer/footer.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class FooterComponent implements OnInit {
  styleClass$: Observable<string> = this.componentData.data$.pipe(map((d) => d.styleClass));
  breakPointSize: any;

  footerData$: Observable<any> = this.componentData.data$.pipe(
    pluck('navigationNode', 'children'),
    switchMap((footerData) =>
      combineLatest([
        of(footerData.map((footer) => footer?.children[0]?.entries[0] || {})),
        this.activeCountry$,
        this.activeLanguage$,
        this.breakpoint$,
      ])
    ),
    switchMap(([links, activeCountry, activeLanguage, breakpoint]) =>
      forkJoin([of(links), this.footerService.getBreakAfterIndex(activeCountry, activeLanguage, breakpoint)])
    ),
    map(([links, breakAfterIndex]) => ({ links, breakAfterIndex }))
  );

  constructor(
    private componentData: CmsComponentData<CmsNavigationComponent>,
    private countryService: ShimanoCountryService,
    private languageService: ShimanoLanguageService,
    private footerService: FooterService,
    private breakpointService: BreakpointService
  ) {}
  ngOnInit() {
    this.breakpoint$.subscribe((data: any) => {
      this.breakPointSize = data;
    });
  }

  get activeCountry$(): Observable<string> {
    return this.countryService.getActive();
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  get breakpoint$(): Observable<BREAKPOINT> {
    return this.breakpointService.breakpoint$;
  }
}
